// The Tawk.to bubble is a fixed element in the bottom corner of every
// logged-out page. Replays from Aug 27 to Sep 22 2026 showed it, and the
// greeting card it opens by itself, sitting on the sign-up form's Terms
// checkbox, its submit button and the role cards on phones. Park it while
// an auth form is on screen. Returns the function that brings it back.
export const parkTawk = () => {
  const api = window.Tawk_API;
  if (!api) return () => {};
  const call = (fn) => {
    if (typeof api[fn] !== "function") return;
    try {
      api[fn]();
    } catch (err) {
      // The widget is still booting; onLoad below catches that case.
    }
  };
  const previousOnLoad = api.onLoad;
  call("hideWidget");
  api.onLoad = () => {
    if (typeof previousOnLoad === "function") previousOnLoad();
    call("hideWidget");
  };
  return () => {
    api.onLoad = previousOnLoad;
    // Phones never get the bubble back: the layout hides it there for good.
    if (!window.swyvelTawkPhone) call("showWidget");
  };
};
